<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item">
        <ValidationObserver v-slot="{ failed, passed }">
          <form>
            <md-card class="p-25">
              <div>
                <md-card-content>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-30 md-small-size-100">
                      <md-field
                        :class="[
                          { 'md-error': failed },
                          { 'md-valid': passed },
                        ]"
                      >
                        <p class="validate">*</p>
                        <label>اسم الاستقطاع</label>
                        <md-input v-model="deductionName"></md-input>
                      </md-field>
                    </div>

                    <div class="md-layout-item md-size-30 md-small-size-100">
                      <md-field>
                        <p class="validate">*</p>
                        <label>نوع الاستقطاع</label>
                        <md-select v-model.number="deductionType">
                          <md-option :value="1">متكرر</md-option>
                          <md-option :value="2">مرة واحدة</md-option>
                        </md-select>
                      </md-field>
                    </div>

                    <div class="md-layout-item md-size-30 md-small-size-100">
                      <md-field>
                        <p class="validate">*</p>
                        <label>مدة سداد الاستقطاع</label>
                        <md-select v-model.number="deductionPaymentDuration">
                          <md-option :value="1">شهر واحد</md-option>
                          <md-option :value="2">عدة أشهر</md-option>
                          <md-option :value="3">مستمر</md-option>
                        </md-select>
                      </md-field>
                    </div>

                    <div
                      class="md-layout-item md-size-100 center-content mt-25"
                    >
                      <md-button @click="Save" class="md-success btn_nanosoft"
                        >حفظ</md-button
                      >
                      <md-button @click="clear" class="md-info btn_nanosoft"
                        >جديد</md-button
                      >
                    </div>
                  </div>
                </md-card-content>
              </div>
            </md-card>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <div class="md-layout-item">
      <md-card>
        <md-card-content>
          <div class="md-layout flex-content-left"></div>

          <md-table
            :value="tableData"
            class="paginated-table table-striped table-hover mt-25"
          >
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="اسم الاستقطاع">{{
                item.deductionName
              }}</md-table-cell>
              <md-table-cell md-label="نوع الاستقطاع">{{
                item.deductionType == 1 ? "متكرر" : "مرة واحدة"
              }}</md-table-cell>
              <md-table-cell md-label="مدة السداد">{{
                item.deductionPaymentDuration == 1
                  ? "شهر واحد"
                  : item.deductionPaymentDuration == 2
                  ? "عدة أشهر"
                  : "مستمر"
              }}</md-table-cell>

              <md-table-cell md-label>
                <div class="md-just-icon md-info md-simple"></div>
                <md-button
                  class="md-just-icon md-warning md-simple"
                  @click.native="handleEdit(item)"
                >
                  <md-icon>dvr</md-icon>
                </md-button>
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="handleDelete(item)"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  async created() {
    this.init();
  },
  components: {},
  data() {
    return {
      deductionName: "",
      deductionType: null,
      deductionPaymentDuration: null,
      btn: "new",
      idTable: "",
      tableData: [],
    };
  },
  methods: {
    async Save() {
      try {
        if (!this.deductionName) {
          return this.notifyVue(
            "top",
            "center",
            "warning",
            "عفواً، الرجاء ادخال اسم الاستقطاع"
          );
        }
        if (!this.deductionType) {
          return this.notifyVue(
            "top",
            "center",
            "warning",
            "عفواً، الرجاء اختيار نوع الاستقطاع"
          );
        }
        if (!this.deductionPaymentDuration) {
          return this.notifyVue(
            "top",
            "center",
            "warning",
            "عفواً، الرجاء اختيار مدة السداد"
          );
        }

        let schema = {
          DeductionName: this.deductionName,
          DeductionType: this.deductionType,
          DeductionPaymentDuration: this.deductionPaymentDuration,
        };

        if (this.btn === "new") {
          await this.$axios.post(`/api/deductionTypes`, schema);
        } else {
          await this.$axios.put(`/api/deductionTypes/${this.idTable}`, schema);
        }

        this.init();
        this.clear();
        this.btn = "new";
        return this.notifyVue("top", "center", "success", "تم الحفظ بنجاح");
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          error.response?.data?.errors
            ? error.response.data.errors[
                Object.keys(error.response.data.errors)
              ][0]
            : "حدث خطأ أثناء الحفظ"
        );
      }
    },
    async init() {
      try {
        let result = await this.$axios.get(`/api/deductionTypes`);

        let list = result.data?.data || [];
        this.tableData = list.map((d) => ({
          id: d.id,
          deductionName: d.deductionName ?? d.DeductionName,
          deductionType: d.deductionType ?? d.DeductionType,
          deductionPaymentDuration:
            d.deductionPaymentDuration ?? d.DeductionPaymentDuration,
        }));
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "الرجاء اعادة تسجيل الدخول"
        );
      }
    },
    customSort(value) {
      const sortBy = this.currentSort;
      return value.sort((a, b) => {
        if (this.currentSortOrder === "desc") {
          return String(a[sortBy] || "").localeCompare(String(b[sortBy] || ""));
        }
        return String(b[sortBy] || "").localeCompare(String(a[sortBy] || ""));
      });
    },
    async handleEdit(item) {
      const offsetTop = document.getElementById("#content");
      scroll({ top: offsetTop, behavior: "smooth" });
      this.deductionName = item.deductionName;
      this.deductionType = item.deductionType;
      this.deductionPaymentDuration = item.deductionPaymentDuration;
      this.btn = "Edit";
      this.idTable = item.id;
    },
    clear() {
      this.deductionName = "";
      this.deductionType = null;
      this.deductionPaymentDuration = null;
      this.btn = "new";
      this.idTable = "";
    },
    handleDelete(item) {
      Swal.fire({
        text: "سيتم الحذف هل انت متأكد ؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            await this.$axios.delete(`/api/deductionTypes/${item.id}`);
            this.deleteRow(item);
            return this.notifyVue("top", "center", "success", "تم الحذف بنجاح");
          } catch (error) {
            let res = error.response?.data?.errors
              ? error.response.data.errors[
                  Object.keys(error.response.data.errors)[0]
                ][0]
              : "تعذر الحذف";
            return this.notifyVue("top", "center", "danger", res);
          }
        }
      });
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },
  },
};
</script>